import axios from '../utils/axiosInstance';

export const downloadInvitationTemplateAPI = async () => {
  const response = await axios.get('download-respondent-template', {
    responseType: 'blob',
  });
  return response;
};
